export enum ReturnsRoutePathsEnum {
  REQUEST_RETURN_LABEL = 'request-return-label',
  REQUEST_RETURN_LABEL_HASH = 'request-return-label/:hash',
  RETURN = 'returns/:returnCaseId',
  RETURNS = 'returns',
}
